/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drag_Drop_Image_OrInputs */

const en_drag_drop_image_or = /** @type {(inputs: Drag_Drop_Image_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drag and drop an image, or`)
};

const es_drag_drop_image_or = /** @type {(inputs: Drag_Drop_Image_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrastra y suelta una imagen, o`)
};

/**
* | output |
* | --- |
* | "Drag and drop an image, or" |
*
* @param {Drag_Drop_Image_OrInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const drag_drop_image_or = /** @type {((inputs?: Drag_Drop_Image_OrInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drag_Drop_Image_OrInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_drag_drop_image_or(inputs)
	return es_drag_drop_image_or(inputs)
});